import { BaseFile } from "./BaseFile";

export class ExportedPastStockValueFile extends BaseFile
{
    brands

    constructor(params) {
        super(params)

        const { brands } = params

        this.brands = brands
    }

    serailize() {
        return {
            brand_ids: !!this.brands ? this.brands.map(item => item.id) : null,
        }
    }
}
